<template>
  <div class="input-box">
    <div class="title">文件列表(按照日报编号-文件名称的方式，一行一个)</div>
    <el-input v-model="input" type="textarea" :rows="8" placeholder="请输入"/>
  </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: ()=>[]
        }
    },
    computed: {
        input: {
            get() {
                return this.value.join('\n')
            },
            set(str) {
                const data = str.split('\n')
                this.$emit('input', data)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-box {
    .title {
        margin-bottom: 10px;
        font-weight: bold;
    }
}
</style>